module.exports = __webpack_public_path__ + "static/media/logo-dark-en.1c4fa685.svg";